export const breakpointsRefresh = {
  xs: '@media (min-width: 576px)',
  sm: '@media (min-width: 640px)',
  md: '@media (min-width: 768px)',
  lg: '@media (min-width: 1024px)',
  xl: '@media (min-width: 1280px)',
  xxl: '@media (min-width: 1536px)'
};

export default breakpointsRefresh;
